module.exports = __webpack_public_path__ + "static/media/default.68723eba.png";